import { ReviewsRoutingService } from '../routing'
import { ReviewsService } from '../services'

export const useReviews = () => {
  const alt = useAlt()

  return {
    get service() {
      return alt.get(ReviewsService)
    },
    get routing() {
      return alt.get(ReviewsRoutingService)
    },
  }
}
